import React from "react"
import { useSelector } from "react-redux"

import ReviewDetail from "@/components/Review/v1/Review.view"
import { selectPdpState } from "@/store/features/pdpSlice"

const Review = props => {
  const { data } = props
  return <ReviewDetail data={data} />
}

export default Review
